import { render } from "./GameField.vue?vue&type=template&id=54c5dbe0&scoped=true"
import script from "./GameField.vue?vue&type=script&lang=js"
export * from "./GameField.vue?vue&type=script&lang=js"

import "./GameField.vue?vue&type=style&index=0&id=54c5dbe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c5dbe0"]])

export default __exports__